module.exports = __webpack_public_path__ + "trusting_connections-emblem_vector-gold.svg?389d2cb393c0badd1ef33490655c604c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/trusting_connections-emblem_vector-gold.svg
// module id = 15
// module chunks = 0